<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<a id="page_3"></a>
<h1 class="tit1"><span class="bold">A SELECTIVE HISTORY OF</span></h1>
<h1 class="tit2"><span class="bold">‘BAD’</span></h1>
<h1 class="tit3"><span class="bold">VIDEO GAMES</span></h1>
<p class="tit4"><span class="bold">UNFULFILLED POTENTIAL, INTERESTING MISTAKES AND DOWNRIGHT CLUNKERS</span></p>
<p class="author"><span class="bold">Michael Greenhut</span></p>
<div class="img_container1"><img alt="Images" src="images/pub.jpg" style="width:15%;"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2_Title.vue?f51eb0b6